import { NgModule } from "@angular/core";
import { ExpressionEvaluatorFormComponent } from './expression-evaluator-form/expression-evaluator-form.component';
import { DynamicExpressionEvaluatorComponent } from './dynamic-expression-evaluator.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ExpressionEvaluatorDesignComponent } from './expression-evaluator-design/expression-evaluator-design.component';
import { ExpressionEvaluatorResultComponent } from './expression-evaluator-result/expression-evaluator-result.component';
import { MaterialModule } from '../../material.module';
import { KendoModule } from '../kendo.module';
import { AbwConditionalFormatingModule } from '../@core/abw-conditional-text-formating.module';

@NgModule({
    declarations: [
        ExpressionEvaluatorResultComponent,
        ExpressionEvaluatorDesignComponent,
        ExpressionEvaluatorFormComponent, DynamicExpressionEvaluatorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        KendoModule,
        AbwConditionalFormatingModule
    ],
    entryComponents: [
        DynamicExpressionEvaluatorComponent
    ]
})
export class ExpressionEvaluatorModule {}